module.exports = __webpack_public_path__ + "img/moataz-img.53a625e1.jpg";